import {
  Combobox,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
  ComboboxPopup,
} from "@/components/ui/combobox";

import { currencyDisplayName, PRICE_CURRENCIES } from "../lib/money";

/** Ignores case and accents, so "etats" finds "dollar des États-Unis". */
function normalize(text: string): string {
  return text
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}

function matchesCurrency(code: string, query: string): boolean {
  const search = normalize(query.trim());
  return !search || normalize(code).includes(search) || normalize(currencyDisplayName(code)).includes(search);
}

interface CurrencyComboboxProps {
  value: string;
  onChange: (currency: string) => void;
  className?: string;
}

/** Searchable currency picker: matches the ISO code or the French currency name. */
export function CurrencyCombobox({ value, onChange, className }: CurrencyComboboxProps) {
  return (
    <Combobox
      autoHighlight
      items={PRICE_CURRENCIES}
      value={value}
      onValueChange={(currency: string | null) => {
        if (currency) {
          onChange(currency);
        }
      }}
      filter={(currency: string, query: string) => matchesCurrency(currency, query)}
    >
      <ComboboxInput aria-label="Devise" className={className} placeholder="Devise" />
      <ComboboxPopup className="min-w-72">
        <ComboboxEmpty>Aucune devise trouvée.</ComboboxEmpty>
        <ComboboxList>
          {(currency: string) => (
            <ComboboxItem key={currency} value={currency}>
              <span className="truncate">
                <span className="mr-2 font-semibold text-slate-700">{currency}</span>
                {currencyDisplayName(currency)}
              </span>
            </ComboboxItem>
          )}
        </ComboboxList>
      </ComboboxPopup>
    </Combobox>
  );
}
